export function fixGetManyAttachments(json) {
    return {
        data: json.map((resource) => ({
            ...resource,
            ...json,
            id: resource.objectId,
            objectId: resource.objectId,
            attachmentId: resource.objectId,
        })),
    };
}

export function attachmentMapperListResponse(json, headers) {
    return {
        data: json.map((resource) => ({
            ...resource,
            id: resource.objectId,
            attachmentId: resource.objectId,
        })),
        total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
    };
}